import { IPointsMallCouponItem } from '@/api/types/account';
import GoodsDetailCollapse from '@/components/GoodsDetail/GoodsDetailCollapse';
import { Box } from '@mui/material';
import { useTranslations } from 'next-intl';

interface IValidityOtherRestrict {
  x?: number | string;
  y?: number | string;
}

interface couponInfo extends IPointsMallCouponItem {
  validity: number;
  validity_other_restrict: IValidityOtherRestrict;
  validity_details_day_type: number;
}

export default function BenefitTerms({ couponInfo }: { couponInfo: couponInfo }) {
  const t = useTranslations('account.pointsMall.benefitTerms');

  let validText = '';
  // validity 1不限，4领取后XX生效，生效后XX, 5指定日期内有效
  const { validity, validity_other_restrict, time_interval } = couponInfo;
  if (validity === 1) {
    validText = t('validity.indefinitely');
  }
  if (validity === 4) {
    if (Number(validity_other_restrict.x) === 0) {
      validText = t('validity.afterRedemption', { days: validity_other_restrict.y });
    } else if (Number(validity_other_restrict.x) > 0) {
      validText = t('validity.startAfterRedemption', {
        startDays: validity_other_restrict.x,
        validDays: validity_other_restrict.y,
      });
    }
  }
  if (validity === 5 && time_interval.length > 1) {
    validText = t('validity.dateRange', { startDate: time_interval[0], endDate: time_interval[1] });
  }
  return (
    <GoodsDetailCollapse title={t('title')} defaultOpen>
      <Box className="mb-24">
        <p className="text-14 leading-[21px] font-ir">{t('terms.manageCoupons')}</p>
        <p className="text-14 mt-16 leading-[21px] font-ir">
          {t('terms.validPeriod', { validText })}
        </p>
        <p className="text-14 mt-16 leading-[21px] font-ir">{t('terms.returnedCoupons')}</p>
        <p className="text-14 mt-16 leading-[21px] font-ir">{t('terms.withinValidityPeriod')}</p>
        <p className="text-14 mt-16 leading-[21px] font-ir">{t('terms.expiredCoupons')}</p>
      </Box>
    </GoodsDetailCollapse>
  );
}
